import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountLevel4Response, AccountResponse } from 'src/app/models/account.model';
import { CategoryVendorResponse } from 'src/app/models/category.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-expense-categories',
  templateUrl: './expense-categories.component.html',
  styleUrls: ['./expense-categories.component.scss']
})
export class ExpenseCategoriesComponent implements OnInit {
  filterList: string = "";
  filterAccount: number = -1;
  filterStatus: number = -1;
  filterDate: number = 0;
  allAccounts: AccountLevel4Response[] = [];
  mapAllAccounts: { [key: number]: AccountLevel4Response } = {};
  pagination = new PaginationModel(0, 10, 0, 0, [], []);
  categories: CategoryVendorResponse[] = [];
  defaultAccount: AccountLevel4Response = null;
  allCategories: CategoryVendorResponse[] = [];
  toChange: CategoryVendorResponse = null;
  modal: boolean = false;
  toEdit: CategoryVendorResponse = null;

  constructor(
    private toastService: ToastrService,
    private vendorService: VendorService,
    private accountService: AccountService
  ) {

  }

  ngOnInit(): void {
    this.getAccounts();
  }

  editCategory(category: CategoryVendorResponse) {
    this.toEdit = category;
    this.modal = true;
  }

  getAccounts() {
    this.mapAllAccounts = {};
    this.accountService.getAccountsLevel4().subscribe({
      next: (response: ResponseObject) => {
        this.allAccounts = response.data;
        this.allAccounts.forEach((a) => {
          if (a.name.includes('Gastos Generales Administración')) {
            this.defaultAccount = a;
          }
          a.displayId = a.displayId[0] + "." + a.displayId[1] + "." + a.displayId[2] + "." + a.displayId[3];
          this.mapAllAccounts[a.id] = a;
        });
        this.getCategories();
      },
      error: (error) => {
        this.toastService.error("Error al obtener las cuentas");
      }
    })
  }

  getCategories() {
    this.vendorService.getAllCategoriesVendor().subscribe({
      next: (response: ResponseObject) => {
        this.categories = response.data;
        this.categories.forEach((c) => {
          c.accountId = c.accountId ? c.accountId : this.defaultAccount.id;
        });
        this.allCategories = this.categories
        this.filterCategories();
      },
      error: (error) => {
        this.toastService.error("Error al obtener las cuentas");
      }
    })
  }

  aprove(category: CategoryVendorResponse) {
    if (category.validating) {
      return;
    }
    category.validating = true;
    this.vendorService.validateCategory(category).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Categoria validada correctamente!");
        category.validating = false;
        this.getAccounts();
      },
      error: (error) => {
        category.validating = false;
        this.toastService.error("Error al validar la categoria");
      }
    })
  }

  changeCategory() {
    if (this.toChange.changing) {
      return;
    }
    this.toChange.changing = true;
    if (!this.toChange.active) {
      this.vendorService.activateCategory(this.toChange).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Categoria validada correctamente!");
          this.toChange.changing = false;
          this.toChange = null;
          this.getAccounts();
        },
        error: (error) => {
          this.toChange.changing = false;
          this.toastService.error("Error al activar la categoria");
        }
      })
    } else {
      this.vendorService.deleteCategory(this.toChange).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Categoria eliminada correctamente!");
          this.toChange.changing = false;
          this.toChange = null;
          this.getAccounts();
        },
        error: (error) => {
          this.toChange.changing = false;
          this.toastService.error("Error al eliminar la categoria");
        }
      })
    }
  }

  filterCategories() {
    this.categories = this.allCategories.filter((c) => {
      if (this.filterList) {
        if (!c.name.toLowerCase().includes(this.filterList.toLowerCase())) {
          return false;
        }
      }
      if (this.filterAccount !== -1) {
        if (c.accountId !== this.filterAccount) {
          return false;
        }
      }
      if (this.filterStatus !== -1) {
        var temp = c.validated ? 1 : 0;
        if (temp !== this.filterStatus) {
          return false;
        }
      }
      return true;
    });
    this.categories.sort((a, b) => {
      if (this.filterDate == 0) {
        return b.creationDate - a.creationDate;
      } else {
        return a.creationDate - b.creationDate;
      }
    });
    this.pagination.total = this.categories;
    this.filterPagination();
  }

  filterPagination() {
    this.pagination.startElement = 0;
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.pageSize;
    this.pagination.filter = this.pagination.total.slice(this.pagination.startElement, this.pagination.lastElement);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  closeModal(event) {
    if (event) {
      console.log(event);
      this.getCategories();
    }
    this.toEdit = null;
    this.modal = false;
  }
}
